<script setup lang="ts">
import { computed, ref, toRef } from 'vue';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import { getColor } from '@/utils/config/constants';
import createTree from "../../utils/create-tree";
import BaseButton from '../ui/buttons/BaseButton.vue';
import { RetrieveClaimWithRelationsResponse } from '@/interfaces';
import SendEventModal from '../ui/modals/SendEventModal.vue';

const props = defineProps<{ claim: RetrieveClaimWithRelationsResponse }>();
const claim = toRef(props, 'claim');

// const tree = computed(() => {
//   const states = machineState.value.toStrings()
//   const stateValue = states[states.length - 1]
//   return stateValue;
//   return createTree(stateValue);
// });

const legalStepColor = computed(() => {
  return getColor(claim.value.claimLegalStep.name);
});

const lastEvent = computed(() => {
  if (claim.value?.claimEvents?.length) {
    return claim.value.claimEvents[claim.value.claimEvents.length - 1]
  }
})

const sendEvent = ref<{ open: boolean; event: null | string }>({
  open: false,
  event: null
})

</script>
<template>
    <div id="alert-additional-content-4"
         :class="`px-6 py-2 text-${legalStepColor}-800 border-b border-${legalStepColor}-300 bg-${legalStepColor}-50`"
         role="alert">
      <div class="flex items-center">
        <!-- <InformationCircleIcon class="w-5 h-5 mr-2" sr-only="info" fill="currentColor" /> -->
        <!-- <h3 class="text-base font-medium ">État en cours</h3> -->

      </div>
      <div class="my-2 text-sm">
        <div class="inline-flex justify-between w-full">
          <p v-tooltip.right="`Fait suite à « ${claim.claimEvents[claim.claimEvents.length -1]?.eventType.displayName} »`">
            Étape : <span class="font-medium">{{ claim.claimState.displayName }}</span>
          </p>
          <span v-if="claim.stateUpdatedAt" class="ml-auto text-xs italic">
            Il y a {{ formatDistanceToNow(new Date(claim.stateUpdatedAt), { locale: fr }) }}
          </span>
        </div>
        <!-- <summary>Étape : <span class="font-medium">{{tree}}</span></summary> -->
        <!-- <div v-html="tree"></div> -->
      </div>
      <div v-if="claim.claimState.description" class="flex py-2 text-sm leading-6 text-left">
        {{ claim.claimState.description }}
      </div>
      <div v-if="lastEvent?.eventType.description" class="flex py-2 text-sm leading-6 text-left">
        <p class="italic">
          <!-- ici -->
          <!-- <pre>{{ lastEvent }}</pre> -->
          {{ lastEvent.eventType.description }}
        </p>
        <!-- <p>
          {{ claim.claimEvents[0] }}
        </p> -->

        <!-- <BaseButton v-if="claim.claimState.type === 'MONEY_RECEIVED'"
          type="primary"
          text="Marquer comme payé au créancier"
          @click="sendEvent.open = true"
        />
        <SendEventModal
          :open="sendEvent.open"
          :event="sendEvent.event"
          @cancel="sendEvent.open = false"
          @close="sendEvent.open = false"
          @confirm="sendEvent.open = false"
        /> -->
        <!-- <button type="button" class="text-white bg-yellow-800 hover:bg-yellow-900 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-xs px-3 py-1.5 mr-2 text-center inline-flex items-center dark:bg-yellow-300 dark:text-gray-800 dark:hover:bg-yellow-400 dark:focus:ring-yellow-800">
          <svg aria-hidden="true" class="-ml-0.5 mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"></path></svg>
          Étape suivante
        </button> -->
        <!-- <button type="button" class="text-yellow-800 bg-transparent border border-yellow-800 hover:bg-yellow-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-xs px-3 py-1.5 text-center dark:hover:bg-yellow-300 dark:border-yellow-300 dark:text-yellow-300 dark:hover:text-gray-800 dark:focus:ring-yellow-800" data-dismiss-target="#alert-additional-content-4" aria-label="Close"> -->
        <!-- Étape suivante -->
        <!-- </button> -->
      </div>
    </div>
</template>